import { AssortmentProductTypeResult, View } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { isDefined } from '@/utils/isDefined';
import { ImageParams, stringifyImageParams } from './stringifyImageParams';

const setAppearance = (productTypeImageUrl: string, appearanceId: string) =>
  appearanceId
    ? productTypeImageUrl.replace(/(\/appearances\/)\d+/, `$1${appearanceId}`)
    : productTypeImageUrl;

export const getProductTypeImageUrl = (view: View, appearanceId: string, params: ImageParams) =>
  setAppearance(
    assertDefined(view.resources.find((resource) => !isDefined(resource.type))).href,
    appearanceId
  ) + stringifyImageParams(params);

export const getProductTypeOverlayImageUrl = (
  view: View,
  appearanceId: string,
  params: ImageParams
) => {
  const overlayUrl = view.resources.find((resource) => resource.type === 'overlay')?.href;
  if (overlayUrl) {
    return setAppearance(overlayUrl, appearanceId) + stringifyImageParams(params);
  }
};

export const getProductTypeImageUrlFromAssortmentProductType = (
  productType: AssortmentProductTypeResult,
  appearanceId: string
) => setAppearance(productType.imageUrl, appearanceId);
